import React from 'react';
import { useTranslation } from 'react-i18next';
import EBPPreviewTable from '../export_builder_advanced/EBPPreviewTable';
import { ExportBuilderAdvancedColumn } from '../../../../types/export_builder_advanced';

interface LoadSheetEBPPreviewPageProps {
  templateId: number | null | undefined;
  ebpTemplateColumns: ExportBuilderAdvancedColumn[] | undefined;
  isLoadingEbpPreview: boolean;
  previewError: string | null;
}

const LoadSheetEBPPreviewPage: React.FC<LoadSheetEBPPreviewPageProps> = ({
  templateId,
  ebpTemplateColumns,
  isLoadingEbpPreview,
  previewError,
}) => {
  const { t } = useTranslation();

  const renderPreviewContent = () => {
    if (previewError) {
      return <div className="load-sheet__ebp-error-message">{previewError}</div>;
    }

    if (templateId) {
      return (
        <>
          {ebpTemplateColumns && ebpTemplateColumns.length > 0 ? (
            <div className="h-96">
              <EBPPreviewTable
                setDrawerVisible={() => {}}
                templateColumns={(ebpTemplateColumns || []).map(
                  (t: ExportBuilderAdvancedColumn) => ({
                    id: t.id,
                    label: t.name,
                    number: t.number,
                    dataKey: t.code,
                    key: t.id,
                  })
                )}
                updateColumnsOrder={() => {}}
                fetching={false}
                preview={[]}
                segment="loadSheets"
              />
            </div>
          ) : (
            <div className="load-sheet__ebp-no-data-message">
              {isLoadingEbpPreview ? t('loadSheets:loading') : t('loadSheets:noEBPTemplateColumn')}
            </div>
          )}
        </>
      );
    }
  };

  return <div className="load-sheet__ebp-content">{renderPreviewContent()}</div>;
};

export default LoadSheetEBPPreviewPage;
